import React from "react";
import "./Tivi.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

export default function Tivi() {
  return (
    <div className="tv-page">
      {/* HERO */}
      <section className="tv-hero">
        <Navbar />
        <div className="tv-container">
          <h1 className="tv-title">
            Sửa tivi tại nhà Uy tín, Nhanh chóng, Chuyên Nghiệp TpHCM
          </h1>

          <p className="tv-intro">
            {/* Đặt đoạn mở đầu của bạn ở đây */}
            Bạn đang tìm một đơn vị chuyên sửa chữa các loại Tivi từ dòng LCD
            cho tới CRT, LED, OLED, QLED, 3D, 4K,… Hãy gọi ngay{" "}
            <strong>
              Điện Lạnh Sài Gòn – địa chỉ sửa tivi tại nhà Uy tín, Nhanh chóng,
              Chuyên Nghiệp
            </strong>
            .
          </p>

          <a href="tel:0833519223" className="tv-btn tv-btn-hotline">
            HOTLINE: 0833 519 223
          </a>

          <figure className="tv-hero-img">
            {/* ẢNH BANNER CHÍNH – THAY ĐƯỜNG DẪN TẠI ĐÂY */}
            <img src="/tivi1.jpg" alt="Dịch vụ sửa tivi tại nhà TPHCM" />
            <figcaption>Dịch vụ sửa tivi tại nhà TpHCM</figcaption>
          </figure>
        </div>
      </section>

      {/* GIỚI THIỆU & ƯU ĐIỂM */}
      <section className="tv-section">
        <div className="tv-container">
          <h2>Sửa tivi giá rẻ tại TPHCM – Điện Lạnh Sài Gòn</h2>

          <p>
            {/* đoạn mô tả ngắn */}
            Cam kết sửa chữa được tất cả các hãng, các dòng tivi hiện nay kể cả
            hàng nội địa. Dịch vụ của chúng tôi có các ưu điểm sau:
          </p>

          <ul className="tv-list">
            <li>
              Đội ngũ kỹ thuật viên được tuyển chọn khắt khe, tay nghề cao, có
              trách nhiệm trong công việc.
            </li>
            <li>
              Sửa chữa tất cả các lỗi, các dòng tivi từ tivi thường tới smart
              tivi hiện đại.
            </li>
            <li>
              Giá sửa tivi hợp lý, phải chăng, được niêm yết rõ ràng cho khách
              trước khi sửa.
            </li>
            <li>
              Có mặt nhanh tại nhà khách hàng chỉ khoảng 30 phút khu vực TP.HCM.
            </li>
          </ul>

          <figure className="tv-image">
            {/* ẢNH KỸ THUẬT SỬA TIVI – THAY ĐƯỜNG DẪN */}
            <img src="/tivi2.jpg" alt="Sửa tivi tận nhà" />
            <figcaption>Sửa tivi tận nhà</figcaption>
          </figure>
        </div>
      </section>

      {/* HÌNH LỚN + CTA GIỮA TRANG */}
      <section className="tv-section tv-section-gray">
        <div className="tv-container">
          <figure className="tv-image">
            {/* ẢNH BOARD MẠCH – THAY ĐƯỜNG DẪN */}
            <img src="/tivi3.jpg" alt="Kỹ thuật viên sửa board tivi" />
          </figure>

          <div className="tv-center">
            <a href="tel:0833519223" className="tv-btn tv-btn-hotline">
              TỔNG ĐÀI: 0833 519 223
            </a>
          </div>
        </div>
      </section>

      {/* CÁC LỖI THƯỜNG GẶP */}
      <section className="tv-section">
        <div className="tv-container">
          <h2>Các lỗi tivi thường gặp, cần nên gọi thợ</h2>

          <div className="tv-fault-block">
            <h3>1. BỆNH NGUỒN</h3>
            <ul className="tv-list">
              <li>Có mùi khét do cháy nổ cầu chì, linh kiện.</li>
              <li>Tivi bật máy 5–15 phút mới khởi động.</li>
              <li>Tivi chạy nhưng sau khoảng 3–10s tự tắt máy.</li>
              <li>Tivi không có đèn báo nguồn.</li>
            </ul>
          </div>

          <div className="tv-fault-block">
            <h3>2. BỆNH CAO ÁP</h3>
            <ul className="tv-list">
              <li>Tivi chạy 2–5 giây rồi tắt máy.</li>
              <li>Màn hình thấy ảnh tối, thiếu sáng.</li>
              <li>Màn hình chỉ sáng một nửa hoặc chỗ sáng chỗ tối.</li>
              <li>Hiện tượng có tiếng nhưng không có ánh sáng.</li>
            </ul>
          </div>

          <div className="tv-fault-block">
            <h3>3. BỆNH BO KHIỂN</h3>
            <ul className="tv-list">
              <li>Tivi không nhận tín hiệu từ máy tính hoặc remote.</li>
              <li>Không nhận điều khiển, kẹt logo, không vào được menu.</li>
              <li>Đèn báo nguồn thường xuyên ở trạng thái màu vàng.</li>
            </ul>
          </div>

          <div className="tv-fault-block">
            <h3>4. BỆNH PANEL (MÀN HÌNH LCD)</h3>
            <ul className="tv-list">
              <li>Hiện tượng trắng màn, hình mờ sương, lem màu.</li>
              <li>Màn hình xuất hiện nhiều sọc ngang dọc, bóng chữ.</li>
              <li>Ảnh hiển thị sai lệch màu sắc, các nét chữ bị vỡ.</li>
              <li>Màn hình bị mất 1/3 hoặc 2/3 không hiển thị được.</li>
            </ul>
          </div>

          <figure className="tv-image">
            {/* ẢNH KỸ THUẬT KHÁC – THAY ĐƯỜNG DẪN */}
            <img src="/tivi4.jpg" alt="Sửa main tivi" />
          </figure>

          <div className="tv-center">
            <a href="tel:0833519223" className="tv-btn tv-btn-hotline">
              BẤM GỌI THỢ SỬA TIVI
            </a>
          </div>
        </div>
      </section>

      {/* BẢNG GIÁ */}
      <section className="tv-section tv-section-gray">
        <div className="tv-container">
          <h2>Bảng giá sửa tivi tận nhà của Điện Lạnh Sài Gòn</h2>
          <p>
            Để khách hàng có thể tham khảo chi phí sửa tivi, chúng tôi cung cấp
            bảng giá tham khảo như sau (giá thực tế còn phụ thuộc kích thước và
            tình trạng tivi):
          </p>

          <div className="tv-table-wrap">
            <table className="tv-table">
              <thead>
                <tr>
                  <th>DỊCH VỤ SỬA TIVI</th>
                  <th>ĐƠN GIÁ (VNĐ)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Sửa tivi bị sọc màn hình</td>
                  <td>650.000đ – 960.000đ</td>
                </tr>
                <tr>
                  <td>Sửa tivi mất hình chỉ còn tiếng</td>
                  <td>550.000đ – 880.000đ</td>
                </tr>
                <tr>
                  <td>Sửa tivi hình chồng lên nhau, loạn hình ảnh</td>
                  <td>750.000đ – 1.280.000đ</td>
                </tr>
                <tr>
                  <td>Sửa tivi bị bóng mờ, nhòe hình</td>
                  <td>550.000đ – 850.000đ</td>
                </tr>
                <tr>
                  <td>Sửa tivi mất nguồn</td>
                  <td>550.000đ – 1.380.000đ</td>
                </tr>
                {/* … thêm các dòng còn lại nếu cần */}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* QUY TRÌNH */}
      <section className="tv-section">
        <div className="tv-container">
          <h2>Quy Trình Sửa Chữa Tivi Tại Điện Lạnh Sài Gòn</h2>

          <div className="tv-step">
            <h3>1. Liên hệ tư vấn CSKH</h3>
            <p>
              Khách hàng liên hệ với bộ phận kỹ thuật, kỹ thuật viên sẽ đến tận
              nhà để kiểm tra tivi. Mọi chi phí đi lại do công ty chi trả, khách
              không phải trả bất kỳ khoản phí nào nếu không đồng ý sửa chữa.
            </p>
          </div>

          <div className="tv-step">
            <h3>2. Kiểm tra tivi</h3>
            <p>
              Nhân viên sẽ kiểm tra chi tiết tivi, nếu không có lỗi nghiêm trọng
              có thể xử lý ngay tại chỗ, trường hợp phức tạp sẽ mang tivi về
              trung tâm để xử lý chuyên sâu.
            </p>
          </div>

          <div className="tv-step">
            <h3>3. Sửa chữa, bàn giao tivi</h3>
            <p>
              Sau khi có kết quả kiểm tra, kỹ thuật viên báo giá, nếu khách hàng
              đồng ý mới tiến hành sửa chữa, thay thế linh kiện. Sửa xong cho
              khách kiểm tra lại trước khi bàn giao.
            </p>
          </div>

          <div className="tv-step">
            <h3>4. Bảo Hành – Hậu mãi</h3>
            <p>
              Tivi sau khi sửa đều có phiếu bảo hành rõ ràng, thời hạn từ 3–12
              tháng tùy hạng mục. Hỗ trợ khách hàng 24/7 khi tivi có phát sinh
              lỗi trong thời gian bảo hành.
            </p>
          </div>
        </div>
      </section>

      {/* ƯU ĐÃI + DANH SÁCH QUẬN */}
      <section className="tv-section tv-section-gray">
        <div className="tv-container">
          <div className="tv-benefit-table">
            <div className="tv-benefit-row">
              <span>✅ HOTLINE</span>
              <span>📞 0833 519 223</span>
            </div>
            <div className="tv-benefit-row">
              <span>✅ Dịch Vụ</span>
              <span>🌟 Uy Tín – Chuyên Nghiệp</span>
            </div>
            <div className="tv-benefit-row">
              <span>✅ Bảo Hành</span>
              <span>🕒 Dài Hạn</span>
            </div>
            <div className="tv-benefit-row">
              <span>✅ Hỗ Trợ</span>
              <span>📍 Toàn Quốc / Toàn Tp.HCM</span>
            </div>
          </div>

          <h2>Gọi Thợ sửa tivi tại nhà nhanh chóng.</h2>
          <p>Bấm gọi chi nhánh gần quý khách để được phục vụ tốt nhất!</p>

          <div className="tv-district-grid">
            <div className="tv-district-col">
              <a href="tel:0994307835">Bấm gọi thợ sửa tivi tại Quận 1</a>
              <a href="tel:0994307835">Bấm gọi thợ sửa tivi tại Quận 2</a>
              <a href="tel:0994307835">Bấm gọi thợ sửa tivi tại Quận 3</a>
              <a href="tel:0994307835">Bấm gọi thợ sửa tivi tại Quận 4</a>
              <a href="tel:0994307835">Bấm gọi thợ sửa tivi tại Quận 5</a>
              <a href="tel:0994307835">Bấm gọi thợ sửa tivi tại Quận 7</a>
            </div>

            <div className="tv-district-col">
              <a href="tel:0994307835">Bấm gọi thợ sửa tivi tại Quận 8</a>
              <a href="tel:0994307835">Bấm gọi thợ sửa tivi tại Quận 9</a>
              <a href="tel:0994307835">Bấm gọi thợ sửa tivi tại Quận 10</a>
              <a href="tel:0994307835">Bấm gọi thợ sửa tivi tại Quận 11</a>
              <a href="tel:0994307835">Bấm gọi thợ sửa tivi tại Gò Vấp</a>
              <a href="tel:0994307835">Bấm gọi thợ sửa tivi tại Quận 12</a>
            </div>

            <div className="tv-district-col">
              <a href="tel:0994307835">Bấm gọi thợ sửa tivi tại Tân Bình</a>
              <a href="tel:0994307835">Bấm gọi thợ sửa tivi tại Bình Thạnh</a>
              <a href="tel:0994307835">Bấm gọi thợ sửa tivi tại Bình Tân</a>
              <a href="tel:0994307835">Bấm gọi thợ sửa tivi tại Thủ Đức</a>
              <a href="tel:0994307835">Bấm gọi thợ sửa tivi tại Tân Phú</a>
              <a href="tel:0994307835">
                Bấm gọi thợ sửa tivi tại Hóc Môn / Nhà Bè
              </a>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </div>
  );
}
